import { FetchDatevEmployeeImportDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import SafeLocalStorage from 'modules/core/lib/SafeLocalStorage'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import Callout from './Callout'
import { IMPORT_STATES } from './importStates'

const DatevImporterCallout = () => {
  const { company, access } = useCurrentSession()

  const { data: processingEmployeeImport } = useQuery(FetchDatevEmployeeImportDocument, {
    variables: {
      companyId: company.id,
      status: IMPORT_STATES.PROCESSING,
    },
  })

  const { data: successfulEmployeeImport } = useQuery(FetchDatevEmployeeImportDocument, {
    variables: {
      companyId: company.id,
      status: IMPORT_STATES.PROCESSED,
    },
  })

  const nodes =
    processingEmployeeImport?.integrationsDatevLauds?.employeeImportsConnection?.nodes || []
  const successNodes =
    successfulEmployeeImport?.integrationsDatevLauds?.employeeImportsConnection?.nodes || []
  const processingResult = nodes[nodes?.length - 1]
  const successfulResult = successNodes[successNodes?.length - 1]
  const accessId = processingResult?.accessId || successfulResult?.accessId || 0
  const importType = processingResult?.importType || successfulResult?.importType || ''
  const validEmployeesCount =
    processingResult?.validEmployeesCount || successfulResult?.validEmployeesCount || 0

  const [successfulBanner, setSuccessfulBanner] = useLocalStorage<boolean>(
    `factorial:showSuccessfulEmployeeBanner_${company.id}`,
    true
  )

  const successfulBannerExists = SafeLocalStorage.getItem(
    `factorial:showSuccessfulEmployeeBanner_${company.id}`,
    null
  )

  if (successfulBannerExists === null && successfulResult?.id !== undefined)
    setSuccessfulBanner(true)

  if (Number(accessId) !== Number(access.id)) return null
  if (validEmployeesCount === 0) return null
  if (processingResult === undefined && successfulResult === undefined) return null

  const calloutType = () => {
    if (processingResult !== undefined) {
      return IMPORT_STATES.PROCESSING
    } else if (successfulResult !== undefined) {
      return IMPORT_STATES.PROCESSED
    } else {
      return ''
    }
  }

  const closeBanner = () => {
    setSuccessfulBanner(false)
  }

  if (successfulBanner === false) return null

  if (importType !== 'from_datev') return null

  return (
    <Callout
      calloutType={calloutType()}
      validEmployeesCount={validEmployeesCount}
      closeBanner={closeBanner}
    />
  )
}

export default DatevImporterCallout
